import React, { useEffect, useState } from 'react'
import Grid from '@material-ui/core/Grid';
import './flights.css';
import { AirplaneComponent, FlightBack, FlightDetailComponent, MidAirport, SelectFlight } from './flightsComponents';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { DurationLayover, secondsToHms } from '../../../utility/utility';
import InfiniteScroll from 'react-infinite-scroll-component';
import { cancelLoading, saveFlight, sortFlightList, updateDepartureFlight, updateFlightMode, updateFlightPage, updateReturnFlight } from './services/Flights.slice';
import { useHistory } from "react-router-dom"
import { checkFlightAvailable, getFlightContractThunk, getFlightsListThunk, getReturnFlightThunk } from './services/Flights.thunks';
import { Loader } from 'semantic-ui-react';
import { Backdrop, CircularProgress, makeStyles } from '@material-ui/core';
import { FlightTestSlice, bookingTestData, departureTestData, returnTestData } from "./services/flightTestData";
import Airline from '../../../assets/images/gairline.png'
import PlayAirline from '../../../assets/images/playLogo.png'
import FlightUpgradeContainer from './FlightUpgradeContainer';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));


export const FlightListComponent = () => {
    const flightListData = useSelector(state => state.Flights.flightListData);
    const flightMode = useSelector(state => state.Flights.flightData.flightMode);
    const selectedDeparture = useSelector(state => state.Flights.selectedDepartureFlight);
    const searchData = useSelector(state => state.Flights.searchData);
    const loadingMore = useSelector(state => state.Flights.loadingMore);
    const isEmptySearch = useSelector(state => state.Flights.isEmptySearch);
    const [selectedUpgradeIndex, setSelectedUpgradeIndex] = useState(null);
    const loading = useSelector(state => state.Flights.loading);

    const reachedEnd = useSelector(state => state.Flights.reachedEnd);

    const [loadingData, setLoading] = useState(false)

    const checkFilters = (flight) => {
        return flight?.airline && flight?.stops && flight?.duration && flight?.prices && flight?.times;
    }

    const classes = useStyles();


    return (

        <div>
            <div style={{
                marginTop: 10,
                paddingBottom: 20
            }} >
                {(flightListData.length > 0) && <div style={{
                    font: "16px/16px Futura Md BT", color: "#E63155", textAlign: "center", padding: '20px 0px', margin: '20px 0px', border: '1px solid #DFDFDF'
                }}> Free cancellation within 24hrs of booking</div>}


                {/* selected Departure Flight */}

                {selectedDeparture && flightMode === 'round_trip' && searchData && searchData.length > 0 && <div style={{
                    paddingBottom: 10
                }}>
                    <FlightItemComponent
                        flightData={selectedDeparture} isDisplay={true} />


                    <FlightBack city={searchData[0].origin.city} />
                </div>}

                <InfiniteScroll
                    style={{ overflow: 'hidden', width: '100%' }}
                    scrollThreshold={0.9}
                    dataLength={flightListData.length} //This is important field to render the next data
                    hasMore={false}
                // next={loadMore}
                >

                    {flightListData.length > 0 && flightListData.map((flight, index) => {
                        if (checkFilters(flight)) {  ///all filters
                            return (
                                <FlightItemComponent
                                    flightData={flight}
                                    isDisplay={false}
                                    flightIndex={index}
                                    setLoading={setLoading}
                                    selectedUpgradeIndex={selectedUpgradeIndex}
                                    setSelectedUpgradeIndex={setSelectedUpgradeIndex}
                                    key={index + "flightItem"} />
                            )
                        }
                        return null;
                    })}
                </InfiniteScroll>

                {flightListData?.length === 0 && !loading && <div style={{
                    font: "21px/21px Futura Md BT", marginTop: 30
                }}>  No results found, please try again.</div>}

                {loadingMore && <div className="flightsLoader" > <CircularProgress thickness={4} style={{ color: '#19BC9B' }} /></div>}
            </div>
            <Backdrop className={classes.backdrop} open={loadingData}  >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}

export const FlightItemComponent = ({ flightData, isDisplay, flightIndex,
    selectedUpgradeIndex, setLoading,
    setSelectedUpgradeIndex }) => {
    const selectedDeparture = useSelector(state => state.Flights.selectedDepartureFlight);
    const selectedFlight = useSelector(state => state.Flights.selectedFlight);
    const flightCurrency = flightData.price_details.display_symbol;
    const flightCurrencyDisplay = flightData.price_details.display_currency;
    const oneclick = useSelector(state => state.PersonalizedTrip.oneclick.active)
    const hotelPPn = useSelector(state => state.PersonalizedTrip.oneclick.hotelPpn)
    const booking_bundles = useSelector(state => state.FormBank.BookingPriceline.booking_bundles);
    const is_mobile = useSelector(state => state.Setting.is_mobile);
    const selectedReturnFlight = useSelector(state => state.Flights.selectedReturnFlight);
    const selectedCurrency = useSelector(state => state.Setting.currency.selected.shortCode);

    const fullCurrency = selectedCurrency ? selectedCurrency.toUpperCase() : "CAD";

    const flightTotalCost = isNaN(flightData.price_details.display_total_fare) && flightData.price_details.display_total_fare ? (flightData.price_details.display_total_fare).toFixed(2) : flightData.price_details.display_total_fare.toFixed(2);
    const flightMode = useSelector(state => state.Flights.flightData.flightMode);
    let flightTicketCost = 0;

    if (isDisplay) {
        flightTicketCost = selectedDeparture?.price_details?.display_total_fare_per_ticket?.toFixed(2);
    }
    else {
        flightTicketCost = selectedDeparture && flightMode === 'round_trip' ? Number(flightData.price_details.display_total_fare - selectedDeparture.price_details.display_total_fare).toFixed(2) : flightData.price_details.display_total_fare_per_ticket.toFixed(2)
    }

    const flightSlice = flightData.slice_data;
    const cost = flightCurrency + flightTicketCost;
    const isRoundTrip = selectedDeparture && flightMode === 'round_trip' && !isDisplay;
    const [itineraryData, setItineraryData] = React.useState()
    const [faresData, setFaresData] = React.useState([])
    const [expandedFlights, setExpandedFlights] = React.useState(new Set())

    const toggleFlightDetails = (sliceIndex) => {
        setExpandedFlights(prev => {
            const newSet = new Set(prev);
            if (newSet.has(sliceIndex)) {
                newSet.delete(sliceIndex);
            } else {
                newSet.add(sliceIndex);
            }
            return newSet;
        });
    };


    const dispatch = useDispatch()
    const history = useHistory()

    const flightPpn = selectedFlight?.ppn_contract_bundle

    const getHotelPpns = () => {
        if (booking_bundles && booking_bundles?.length > 0) {
            const ppns = booking_bundles?.map((bundle) => bundle?.ppn_book_bundle);
            return ppns?.length > 0 ? ppns?.toString() : null
        }
        return null
    }



    const selectFlightRate = (flight) => {

        if (flightMode === 'round_trip') {
            window.scrollTo(0, 0);
            if (selectedDeparture) {
                dispatch(updateReturnFlight(flight));
                dispatch(getFlightContractThunk())

                if (oneclick) {
                    const ppns = getHotelPpns()

                    history.push(`/package?hotelBundle=${ppns}&bundleId=${flight?.ppn_contract_bundle}`)
                }
                else {
                    history.push('/flight/recap')
                }

            }
            else {
                dispatch(getReturnFlightThunk(flight))
                dispatch(updateDepartureFlight(flight));
            }
        }
        else {
            dispatch(updateDepartureFlight(flight));
            dispatch(getFlightContractThunk())
            if (oneclick) {
                const ppns = getHotelPpns()
                history.push(`/package?hotelBundle=${ppns}&bundleId=${flight?.ppn_contract_bundle}`)
            }
            else {
                history.push('/flight/recap')
            }
        }
        dispatch(updateFlightMode(flightMode))  //set flight mode 
        if (flight && flight.slice_data) {
            const savedFlightData = flight.slice_data.map((data) => {
                return {
                    airline_logo: data.airline.logo || "",
                    departure_airport_code: data.departure.airport.code || "",
                    arrival_airport_code: data.arrival.airport.code || "",
                    departure_date: data.departure.datetime.date || "",
                    arrival_date: data.arrival.datetime.date || "",
                    departure_time: data.departure.datetime.time_24h || "",
                    arrival_time: data.arrival.datetime.time_24h || "",
                    flight_duration: data.info.duration || ""
                }
            })
            dispatch(saveFlight(savedFlightData))
        }
    }

    function extractUniqueFareOptions(data) {
        const seen = new Map();
        const cleaned = [];

        if (!Array.isArray(data)) {
            console.error('Invalid input: expected an array');
            return [];
        }

        try {
            data.forEach((item) => {
                const newItem = { ...item };
                const slices = Array.isArray(item?.slice_data) ? item.slice_data : [];

                newItem.slice_data = [];

                slices.forEach((slice) => {
                    const ancillaries = Array.isArray(slice?.ancillaries) ? slice.ancillaries : [];

                    const cancellation = ancillaries.find(a => a.type_code === 'REFUNDS')?.offer_type || 'UNKNOWN';
                    const changes = ancillaries.find(a => a.type_code === 'CHANGES')?.offer_type || 'UNKNOWN';

                    const name = slice?.name || 'Unknown';
                    const key = `${name}|${cancellation}|${changes}`;

                    if (!seen.has(key)) {
                        seen.set(key, true);
                        newItem.slice_data.push(slice);
                    }
                });

                if (newItem.slice_data.length > 0) {
                    cleaned.push(newItem);
                }
            });
        } catch (error) {
            console.error('Error while deduplicating fare options:', error);
        }

        return cleaned;
    }


    const selectFlight = async (flight, noUpgrade) => {

        console.log(flight, noUpgrade, 585)
        if (noUpgrade) {
            setLoading(true);
            const ppnId = flightData?.ppn_contract_bundle;
            const res = await checkFlightAvailable(ppnId, fullCurrency);
            const flightFares = res?.itinerary_data?.upsell_options || [];
            const uniqueFares = extractUniqueFareOptions(flightFares)
            setItineraryData(res?.itinerary_data);
            setFaresData(uniqueFares);

            setLoading(false);
            if (uniqueFares.length > 0) {
                upgradeClick(flightIndex);

            }
            else {

                selectFlightRate(flight)
            }

        }

        else {
            let newFlight = flight;

            if (flight?.upsell_display_total_fare) {
                setLoading(true);
                let res = await checkFlightAvailable(flight?.ppn_contract_bundle, fullCurrency);
                setLoading(false);

                if (res?.itinerary_data?.slice_data?.[1]) {
                    res.itinerary_data.slice_data = [res.itinerary_data.slice_data[1]];
                }
                // Safely combine the old flight with the new one
                newFlight = {

                    ...(res?.itinerary_data || {}), // override with fetched data
                    ppn_contract_bundle: flight?.ppn_contract_bundle // ensure this stays intact
                };

            }
            selectFlightRate(newFlight)

        }



    };


    const days = (date_1, date_2) => {
        const _MS_PER_DAY = 1000 * 60 * 60 * 24;
        // Discard the time and time-zone information.
        const utc1 = Date.UTC(date_1.getFullYear(), date_1.getMonth(), date_1.getDate());
        const utc2 = Date.UTC(date_2.getFullYear(), date_2.getMonth(), date_2.getDate());

        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    }

    const upgradeClick = (index) => {
        if (selectedUpgradeIndex === index) {
            setSelectedUpgradeIndex(null);
        } else {
            setSelectedUpgradeIndex(index);
        }
    }

    const MoreOptions = React.useCallback(() => {
        if (!flightData?.ppn_contract_bundle) {
            return null
        }
        return (
            <div
                onClick={() => upgradeClick(flightIndex)}
                style={{ textAlign: "center", cursor: 'pointer', fontWeight: 600, color: '#19BC9B' }}
                className="flightMore"
            >
                {selectedUpgradeIndex === flightIndex ? 'Hide Options' : 'More Options'}
            </div>
        )
    }, [upgradeClick, flightData, flightIndex, selectedUpgradeIndex])



    return (
        <Grid container style={is_mobile ? {
            marginBottom: 15,
            border: '1px solid #EEE',
            borderRadius: 12,
            background: '#fff',
            boxShadow: '0 2px 10px rgba(0,0,0,0.06)'
        } : { marginBottom: 15 }} >

            <Grid item xs={12} sm={12} md={9} lg={10} >
                {flightSlice && flightSlice.map((slice, sliceIndex) => {
                    const isOG = slice?.airline?.code === "OG" && !slice?.airline?.logo;
                    const logo = isOG ? PlayAirline : slice.airline.logo;
                    const flightSliceData = slice.flight_data;
                    let operated;
                    const notes = slice?.info?.notes;
                    let airlines = "";
                    Object.keys(flightSliceData).forEach(key => {
                        const val = flightSliceData[key]
                        const opr = val?.info?.marketing_airline;
                        const notInclude = !airlines.includes(opr);
                        if (opr && opr.length > 0 && notInclude) {
                            airlines = airlines.concat(opr, '/');
                        }
                    });
                    airlines = airlines.slice(0, -1)

                    operated = slice?.airline?.name ?
                        ` - Operated by ${airlines}  - Total flight duration: ${secondsToHms(slice.info.duration)} ` : ``;

                    // ---- NEW: build mobile "Stops" text list (in-between only) ----
                    const mobileStops = [];
                    if (is_mobile && Array.isArray(flightSliceData) && flightSliceData.length > 1) {
                        for (let i = 0; i < flightSliceData.length - 1; i++) {
                            const seg = flightSliceData[i];
                            const next = flightSliceData[i + 1];
                            const code = seg?.arrival?.airport?.code;
                            const city = seg?.arrival?.airport?.city;
                            const layover = next ? DurationLayover(seg?.arrival?.datetime?.date_time, next?.departure?.datetime?.date_time) : '';
                            if (code) {
                                mobileStops.push({ code, city, layover });
                            }
                        }
                    }
                    // ----------------------------------------------------------------

                    return (
                        <Grid container key={sliceIndex} style={{ border: '1px solid #DFDFDF', height: 'auto', padding: '20px 0px 20px', borderRadius: is_mobile ? 12 : 0, borderColor: is_mobile ? 'transparent' : '#DFDFDF' }}>
                            <img src={logo}
                                onError={({ currentTarget }) => {
                                    currentTarget.onerror = null; // prevents looping
                                    currentTarget.src = Airline;
                                }}
                                height={25} alt="logo" style={{ paddingLeft: is_mobile ? 16 : 40, marginBottom: 10 }} />

                            <Grid container spacing={0} className="flightTimeline">
                                <div className='line'></div>

                                {flightSliceData && flightSliceData.map((flight, index) => {

                                    let DataComponent = [];

                                    const date1 = new Date(flightSliceData[0]?.departure.datetime.date_time);
                                    const date2 = new Date(flightSliceData[flightSliceData.length - 1]?.arrival.datetime.date_time)
                                    const diffDays = days(date1, date2);

                                    if (is_mobile) {

                                        if (index === 0) {
                                            const date = moment(flight.departure.datetime.date).format('MMMM Do');
                                            DataComponent.push(
                                                <Grid item xs={2} key={index + 'depart'} style={{ maxWidth: "38%" }}  >
                                                    <div style={{ textAlign: 'right', background: 'white' }}>
                                                        <FlightDetailComponent flightText={'Depart from'} airportCode={flight.departure.airport.code}
                                                            country={flight.departure.airport.city} date={date} time={flight.departure.datetime.time_12h} />
                                                    </div>
                                                </Grid>
                                            )

                                            DataComponent.push(
                                                <Grid item xs key={index + "airplane"} >
                                                    <div style={{ marginTop: 49 }}>
                                                        <AirplaneComponent time={flightSliceData.length === 1 ? secondsToHms(flight.info.duration) : "..."} />
                                                    </div>
                                                </Grid>
                                            )
                                        }

                                        if (index === flightSliceData.length - 1) {

                                            const date = moment(flight.arrival.datetime.date).format('MMMM Do');

                                            DataComponent.push(
                                                <Grid item xs={2} key={index + 'arrive'} style={{ maxWidth: "38%" }}>
                                                    <div style={{ textAlign: 'left', background: 'white' }}>
                                                        <FlightDetailComponent flightText={'Arrive at'} airportCode={flight.arrival.airport.code} diffDays={diffDays}
                                                            country={flight.arrival.airport.city} date={date} time={flight.arrival.datetime.time_12h} />
                                                    </div>
                                                </Grid>
                                            )
                                        }

                                    }
                                    else {
                                        if (index === 0) {
                                            const date = moment(flight.departure.datetime.date).format('MMMM Do');
                                            DataComponent.push(
                                                <Grid item md={2} key={index + 'depart'}  >
                                                    <div style={{ textAlign: 'right', background: 'white' }}>
                                                        <FlightDetailComponent flightText={'Depart from'} airportCode={flight.departure.airport.code}
                                                            country={flight.departure.airport.city} date={date} time={flight.departure.datetime.time_12h} />
                                                    </div>
                                                </Grid>
                                            )
                                        }

                                        DataComponent.push(
                                            <Grid item md key={index + "airplane"} >
                                                <div style={{ marginTop: 49 }}>
                                                    <AirplaneComponent time={secondsToHms(flight.info.duration)} />
                                                </div>
                                            </Grid>
                                        )

                                        if (index === flightSliceData.length - 1) {

                                            const date = moment(flight.arrival.datetime.date).format('MMMM Do');

                                            DataComponent.push(
                                                <Grid item md={2} key={index + 'arrive'} style={{ marginLeft: 6 }}>
                                                    <div style={{ textAlign: 'left', background: 'white' }}>
                                                        <FlightDetailComponent flightText={'Arrive at'} airportCode={flight.arrival.airport.code} diffDays={diffDays}
                                                            country={flight.arrival.airport.city} date={date} time={flight.arrival.datetime.time_12h} />
                                                    </div>
                                                </Grid>
                                            )
                                        }

                                        else {
                                            const next = index + 1 <= flightSliceData.length - 1 ? flightSliceData[index + 1] : null;
                                            const time = next ? DurationLayover(flight.arrival.datetime.date_time, next.departure.datetime.date_time) : '';

                                            DataComponent.push(
                                                <Grid item md key={index + 'connect'}  >
                                                    <div style={{ margin: '0 auto', marginTop: 49, maxWidth: 130 }}>
                                                        <MidAirport time={time} airportCode={flight.arrival.airport.code} city={flight.arrival.airport.city} />
                                                    </div>
                                                </Grid>
                                            )

                                        }

                                    }

                                    return DataComponent;
                                })
                                }

                            </Grid>


                            <p style={{ marginTop: 20, marginLeft: is_mobile ? 16 : 50, marginBottom: 0, width: "100%", font: "14px/14px Futura Md BT" }}>
                                {slice?.airline?.name}
                                <span style={{ color: '#6b6b6b', font: "14px/14px Futura Md BT" }}>{operated} </span>
                            </p>

                            {flightSliceData &&
                                <div style={{ paddingTop: 15, width: is_mobile ? '100%' : '80%' }}>
                                    {Object.keys(flightSliceData).map((key, index) => {
                                        const val = flightSliceData[key]
                                        const notes = val?.info?.notes;
                                        return (<div key={`notes-wrap-${sliceIndex}-${index}`} style={{ width: '100%', }}>
                                            {notes && Object.keys(notes).map(key => {
                                                const note = notes[key]
                                                return (
                                                    <p key={`note-${sliceIndex}-${index}-${key}`}
                                                        style={{ marginTop: 3, marginBottom: 3, width: "100%", marginLeft: is_mobile ? 16 : 50, lineHeight: 1.3, font: "14px/14px Futura  Lt BT", color: '#E63155', }}>
                                                        {note?.value}
                                                    </p>
                                                )
                                            })}
                                        </div>)
                                    })}
                                </div>}
                        </Grid>
                    )
                })}
            </Grid>

            {/* Mobile collapsible details section - Full width */}
            {is_mobile && flightSlice && flightSlice.some(slice => {
                const flightSliceData = slice.flight_data;
                return Array.isArray(flightSliceData) && flightSliceData.length > 1;
            }) && (
                    <Grid item xs={12} style={{ padding: '0 16px' }}>
                        {flightSlice.map((slice, sliceIndex) => {
                            const flightSliceData = slice.flight_data;
                            const mobileStops = [];
                            if (Array.isArray(flightSliceData) && flightSliceData.length > 1) {
                                for (let i = 0; i < flightSliceData.length - 1; i++) {
                                    const seg = flightSliceData[i];
                                    const next = flightSliceData[i + 1];
                                    const code = seg?.arrival?.airport?.code;
                                    const city = seg?.arrival?.airport?.city;
                                    const layover = next ? DurationLayover(seg?.arrival?.datetime?.date_time, next?.departure?.datetime?.date_time) : '';

                                    if (code) {
                                        mobileStops.push({
                                            code,
                                            city,
                                            layover,
                                            // Arrival details from current segment
                                            arrivalTime: seg?.arrival?.datetime?.time_12h,
                                            arrivalDate: moment(seg?.arrival?.datetime?.date).format('MMM Do'),
                                            arrivalFlight: seg?.flight_number,
                                            arrivalAirline: seg?.info?.marketing_airline,
                                            arrivalDuration: secondsToHms(seg?.info?.duration),
                                            // Departure details from next segment
                                            departureTime: next?.departure?.datetime?.time_12h,
                                            departureDate: moment(next?.departure?.datetime?.date).format('MMM Do'),
                                            departureFlight: next?.flight_number,
                                            departureAirline: next?.info?.marketing_airline,
                                            departureDuration: secondsToHms(next?.info?.duration)
                                        });
                                    }
                                }
                            }

                            if (mobileStops.length === 0) return null;

                            return (
                                <div key={`details-${sliceIndex}`} style={{ marginBottom: '20px' }}>
                                    <button
                                        onClick={() => toggleFlightDetails(sliceIndex)}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            padding: '8px 0',
                                            cursor: 'pointer',
                                            width: '100%',
                                            textAlign: 'left',
                                            font: "14px/20px Futura Md BT",
                                            color: '#19bc9b'
                                        }}
                                    >
                                        Details
                                    </button>

                                    {expandedFlights.has(sliceIndex) && (
                                        <div style={{
                                            marginTop: '8px',
                                            padding: '12px 0',
                                            borderTop: '1px solid #eee'
                                        }}>
                                            {mobileStops.map((s, i) => (
                                                <div key={`mstop-${sliceIndex}-${i}`} style={{
                                                    margin: '8px 0',
                                                    padding: '12px',
                                                    backgroundColor: '#f8f9fa',
                                                    borderRadius: '8px',
                                                    border: '1px solid #e9ecef'
                                                }}>
                                                    {/* Airport Header */}
                                                    <div style={{
                                                        marginBottom: '12px',
                                                        paddingBottom: '8px',
                                                        borderBottom: '1px solid #dee2e6'
                                                    }}>
                                                        <p style={{
                                                            margin: '0 0 4px 0',
                                                            lineHeight: 1.35,
                                                            font: "16px/20px Futura Md BT",
                                                            color: '#222',
                                                            fontWeight: 'bold'
                                                        }}>
                                                            {s.code}{s.city ? ` — ${s.city}` : ''}
                                                        </p>
                                                        {s.layover && (
                                                            <p style={{
                                                                margin: '0',
                                                                lineHeight: 1.35,
                                                                font: "12px/16px Futura Lt BT",
                                                                color: '#19bc9b',
                                                                fontWeight: 'bold'
                                                            }}>
                                                                Layover: {s.layover}
                                                            </p>
                                                        )}
                                                    </div>

                                                    {/* Arrival Details */}
                                                    <div style={{ marginBottom: '8px' }}>
                                                        <p style={{
                                                            margin: '0 0 4px 0',
                                                            font: "12px/16px Futura Md BT",
                                                            color: '#666',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px'
                                                        }}>
                                                            Arriving
                                                        </p>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                            <div>
                                                                <p style={{
                                                                    margin: '0',
                                                                    font: "14px/18px Futura Md BT",
                                                                    color: '#222'
                                                                }}>
                                                                    {s.arrivalTime} • {s.arrivalDate}
                                                                </p>
                                                                <p style={{
                                                                    margin: '0',
                                                                    font: "12px/16px Futura Lt BT",
                                                                    color: '#666'
                                                                }}>
                                                                    {s.arrivalAirline}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Departure Details */}
                                                    <div>
                                                        <p style={{
                                                            margin: '0 0 4px 0',
                                                            font: "12px/16px Futura Md BT",
                                                            color: '#666',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px'
                                                        }}>
                                                            Departing
                                                        </p>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                            <div>
                                                                <p style={{
                                                                    margin: '0',
                                                                    font: "14px/18px Futura Md BT",
                                                                    color: '#222'
                                                                }}>
                                                                    {s.departureTime} • {s.departureDate}
                                                                </p>
                                                                <p style={{
                                                                    margin: '0',
                                                                    font: "12px/16px Futura Lt BT",
                                                                    color: '#666'
                                                                }}>
                                                                    {s.departureAirline}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </Grid>
                )}

            {/* spacing hack */}
            <Grid item xs={false} sm={false} md={1} style={{ maxWidth: 10 }}>
            </Grid>

            <Grid item md xs={12} style={{ border: '1px solid #DFDFDF' }}>
                <SelectFlight firstLegPrice={selectedDeparture?.price_details?.display_total_fare?.toFixed(2)} roundTripMode={flightMode === 'round_trip'} flightCost={flightTicketCost} isDisplay={isDisplay} selectFlight={() => { selectFlight(flightData, true) }} isRoundTrip={isRoundTrip} flightSymbol={flightCurrency} cost={cost} total={flightTotalCost} currency={flightCurrencyDisplay} />
            </Grid>

            {selectedUpgradeIndex === flightIndex && flightData?.ppn_contract_bundle &&
                <Grid item xs={12} style={{}}>
                    <FlightUpgradeContainer itinerary_data={itineraryData} fares={faresData} flightData={flightData} selectFlight={selectFlight} />
                </Grid>}
        </Grid>

    )
}


